import {OfferType} from "../../offer/types/OfferType";
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {IClientPayload} from "../api/for_you_client";
import {IForYouModal} from "../types/IForYouModal";

export const getPostData = (modalState: IForYouModal): IClientPayload => {
    const regionsData = modalState.regions?.map((region) => region.id);
    const rooms =
        modalState.criteria?.rooms.lower === "" && modalState.criteria?.rooms.upper === ""
            ? {lower: 0, upper: 0}
            : {
                  lower: modalState.criteria?.rooms.lower || 1,
                  upper: modalState.criteria?.rooms.upper || 5
              };

    const criteriaData = {
        rooms,
        area: {
            lower: modalState.criteria?.area.lower || 0,
            upper: modalState.criteria?.area.upper || 0
        },
        price: {lower: 0, upper: modalState.criteria?.budget || 0},
        loan_installment: {
            lower: 0,
            upper: modalState.criteria?.instalment || 0
        }
    };

    const userData = {
        name: modalState.user?.name || "",
        email: modalState.user?.email || "",
        phone: `+${modalState.user?.phone.code}${modalState.user?.phone.number}`,
        marketing_consent: modalState.user?.marketing_consent || false
    };

    return {
        regions: regionsData || [],
        ...criteriaData,
        ...userData,
        types: modalState.types.length ? modalState.types : [OfferType.FLAT, OfferType.HOUSE],
        distance: modalState.distance,
        financing_services: false,
        marketing_consent: modalState.user?.marketing_consent || false,
        survey_source: modalState.source,
        user_source: UserSource.REGISTER_FOR_YOU
    };
};
import {OfferType} from "../../offer/types/OfferType";
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {IClientPayload} from "../api/for_you_client";
import {IForYouModal} from "../types/IForYouModal";

export const getPostData = (modalState: IForYouModal): IClientPayload => {
    const regionsData = modalState.regions?.map((region) => region.id);
    const rooms =
        modalState.criteria?.rooms.lower === "" && modalState.criteria?.rooms.upper === ""
            ? {lower: 0, upper: 0}
            : {
                  lower: modalState.criteria?.rooms.lower || 1,
                  upper: modalState.criteria?.rooms.upper || 5
              };

    const criteriaData = {
        rooms,
        area: {
            lower: modalState.criteria?.area.lower || 0,
            upper: modalState.criteria?.area.upper || 0
        },
        price: {lower: 0, upper: modalState.criteria?.budget || 0},
        loan_installment: {
            lower: 0,
            upper: modalState.criteria?.instalment || 0
        }
    };

    const userData = {
        name: modalState.user?.name || "",
        email: modalState.user?.email || "",
        phone: `+${modalState.user?.phone.code}${modalState.user?.phone.number}`,
        marketing_consent: modalState.user?.marketing_consent || false
    };

    return {
        regions: regionsData || [],
        ...criteriaData,
        ...userData,
        types: modalState.types.length ? modalState.types : [OfferType.FLAT, OfferType.HOUSE],
        distance: modalState.distance,
        financing_services: false,
        marketing_consent: modalState.user?.marketing_consent || false,
        survey_source: modalState.source,
        user_source: UserSource.REGISTER_FOR_YOU
    };
};
